import React, { FunctionComponent, useCallback } from 'react';
import { Dropdown, Menu, Button } from 'antd';
import locale, { localeMap, setLocale, LocaleName } from '@stores/locale';
import css from './LanguageSwitch.module.less';

const LanguageSwitch: FunctionComponent = () => {
  const currentLocale = locale.getState();

  const setLocaleHandler = useCallback(({ key }: { key: string | LocaleName }) => {
    setLocale(key as LocaleName);
  }, []);

  const menu = (
    <Menu
      onSelect={setLocaleHandler}
      selectable
      selectedKeys={[currentLocale]}
    >
      {Object.entries(localeMap).map(([key, value]) => {
        return (
          <Menu.Item
            key={key}
          >
            {value.name}
          </Menu.Item>
        );
      })}
    </Menu>
  );

  return (
    <div className={css.root}>
      <Dropdown overlay={menu}>
        <Button
          type="link"
          className={css.icon}
        >{localeMap[currentLocale].name}</Button>
      </Dropdown>
    </div>
  );
};

export default LanguageSwitch;
